export const requestUrl = {
  backendUrl: 'api/',
  // backendUrl: '192.168.0.1'
};
